<template>
  <div class="card" :class="{'card--selected': isSelected}" @click="onClick">
    <div class="card__gradient"></div>
    <div class="card__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      val: null
    }
  },

  props: {
    value: Object,
    isSelected: Boolean
  },

  mounted: function () {
    this.val = this.value
  },

  methods: {
    onClick () {
      this.$emit('selected', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  @include boxShadow(0px, 1px, 4px, -3px, rgba(0, 0, 0, 0.75));
  position: relative;
  display: flex;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    .card__gradient {
      width: 8px;
    }
  }

  &--selected {
    .card__gradient {
      width: 10px !important;
    }
  }

  &__gradient {
    background-color: $primary;
    position: absolute;
    border-radius: 4px 0px 0px 4px;
    width: 6px;
    height: 100%;
    will-change: transition;
    transition: width 0.1s linear;
  }

  &__content {
    padding: 10px 12px;
    margin-left: 7px;

    & > :first-child {
      font-size: 1.2em;
      margin-bottom: 4px;
    }

    & > :only-child {
      margin-bottom: 0px;
    }

    & > :last-child:not(:first-child) {
      font-size: 0.9em;
      font-style: italic;
    }
  }
}
</style>